var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.params.value),function(tag){return _c('div',{key:tag},[_c('el-tag',[_vm._v(_vm._s(tag))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }